import { v5 as uuidv5 } from "uuid";

const RECENT_CHATS_NAMESPACE = "3d4b929e-d682-417e-a2b8-290163f126a0";

export type RecentChat = {
  serverConversationId: string;
  title: string;
  uuid: string;
};

export function conversationToRecentChat(conversation: {
  serverConversationId: string;
  title: string;
}): RecentChat {
  return {
    uuid: uuidv5(conversation.serverConversationId, RECENT_CHATS_NAMESPACE),
    title: conversation.title,
    serverConversationId: conversation.serverConversationId,
  };
}

export function deduplicateRecentChats(chats: RecentChat[]): RecentChat[] {
  const set = new Set<string>();

  return chats.filter((chat) => {
    if (set.has(chat.title)) return false;
    set.add(chat.title);
    return true;
  });
}
